<template>
  <div></div>
</template>
<script>
import http from "axios";
export default {
  name: "Auth",
  mounted() {
    console.log(this.$store.state.domain);
    http({
      url: `${this.$store.state.domain}/xhs_crm/index.php/ClientApi/token_verify?token=${this.$store.state.token}`
    })
      .then(res => {
        if (res.data === "success") {
          this.$store.state.isAuth = true;
          console.log("auth success");
          this.$router.go(-1);
          return;
        }
        this.$router.push({ name: "no-auth" });
      })
      .catch(() => this.$router.push({ name: "no-auth" }));
  }
};
</script>
